import { PureLightTheme } from "../../../../../styles/theme";

export const CardStyle = {
    padding: 2.5,
    width: "100%",
    [PureLightTheme.breakpoints.down('sm')]: {
        width: "calc(100% + 24px)",
        margin: "0px -12px",
        padding: "12px",
        borderLeft: "none",
        borderRight: "none",
    }
}